import VueSocket from '@/lib/vue3-socket-io';
import { io } from 'socket.io-client';
import WebSocketAPI from '@/apis/system/socketAPI.js';
import store from '@/stores/store';
import { ModuleContext } from '@/stores/moduleConst';
import commonFn from '@/commons/commonFunction';

export const initSocket = async app => {
  app.use(
    new VueSocket({
      vuex: {
        store,
        actionPrefix: 'websocket-global-',
      },
    })
  );
};
